<template>
  <div class="layout">
    <!-- 一级菜单 -->
    <div class="sidebar" :class="{ collapsed: isCollapsed }">
      <div class="logo">
        <span>羚骐动力</span>
      </div>
      <el-menu
        :default-active="activeMenu"
        class="sidebar-menu"
        text-color="#bfcbd9"
        active-text-color="#409EFF"
        @select="handleMenuClick"
      >
        <el-menu-item
          v-for="menu in menus"
          :key="menu.path"
          :index="menu.path"
          :title="menu.title"
        >
          <div class="columns-vertical">
            <i :class="menu.icon"></i>
            <span class="menu-title">{{ menu.title.slice(0, 2) }}</span>
          </div>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 二级菜单 -->
    <div
      class="sub-sidebar"
      :class="{ collapsed: isCollapsed }"
      v-if="currentMenu && currentMenu.children && currentMenu.children.length"
    >
      <el-menu
        :default-active="activeSubMenu"
        class="sub-sidebar-menu"
        :collapse="isCollapsed"
        background-color="#fff"
        text-color="#222"
        active-text-color="#409EFF"
        @select="handleSubMenuClick"
      >
        <el-menu-item
          v-for="subMenu in currentMenu.children"
          :key="subMenu.path"
          :index="subMenu.path"
        >
          <span>{{ subMenu.title }}</span>
        </el-menu-item>
      </el-menu>
    </div>

    <!-- 主内容区 -->
    <div class="main-container">
      <!-- 顶部导航 -->
      <div class="header">
        <div class="header-left">
          <i
            :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="toggleSidebar"
          ></i>
        </div>
        <div class="header-right">
          <div class="notification-icon" @click="goToMessageList">
            <el-badge :value="unreadCount" :hidden="!unreadCount">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
          <el-dropdown>
            <span class="user-info">
              {{ currentUserName }} <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="handleLogout"
                >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import http from "@/utils/http";

export default {
  name: "Layout",
  data() {
    return {
      isCollapsed: false,
      activeMenu: "/home",
      activeSubMenu: "",
      currentMenu: null,
    };
  },
  computed: {
    ...mapState("menu", ["menuData"]),
    ...mapState("message", ["unreadCount"]),
    menus() {
      return this.menuData || [];
    },
    // 获取当前登录用户姓名
    currentUserName() {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        return userInfo.name || "用户";
      } catch (error) {
        console.error("获取用户信息失败:", error);
        return "用户";
      }
    },
  },
  watch: {
    // 监听路由变化，更新菜单选中状态
    '$route'(to, from) {
      this.updateMenuFromRoute();
    },
    // 监听菜单数据变化
    menus: {
      handler() {
        this.updateMenuFromRoute();
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions("menu", ["setMenu"]),
    ...mapActions("message", ["getUnreadCount"]),
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleMenuClick(path) {
      const menu = this.menus.find((m) => m.path === path);
      this.currentMenu = menu;
      this.activeMenu = path;
      if (menu && menu.children && menu.children.length) {
        this.activeSubMenu = menu.children[0].path;
        // 检查当前路径是否与目标路径相同
        const targetPath = `${menu.path}/${menu.children[0].path}`;
        if (this.$route.path !== targetPath) {
          this.$router.push(targetPath);
        }
      } else {
        this.activeSubMenu = "";
        // 检查当前路径是否与目标路径相同
        if (this.$route.path !== path) {
          this.$router.push(path);
        }
      }
    },
    handleSubMenuClick(path) {
      this.activeSubMenu = path;
      if (this.currentMenu) {
        const targetPath = `${this.currentMenu.path}/${path}`;
        // 检查当前路径是否与目标路径相同，避免重复导航
        if (this.$route.path !== targetPath) {
          this.$router.push(targetPath);
        }
      }
    },
    handleLogout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
    goToMessageList() {
      this.$router.push("/message");
    },
    initMenu() {
      http
        .getRequest("/api/ajax/init")
        .then((res) => {
          if (res.code === 200) {
            this.setMenu(res.data); // 只通过 action 更新数据
            // 在获取到菜单数据后设置当前菜单
            this.updateMenuFromRoute();
          } else {
            this.$message.error(res.msg || "菜单初始化失败");
          }
        })
        .catch(() => {
          this.$message.error("菜单初始化接口异常");
        });
    },
    // 根据路由更新菜单选中状态
    updateMenuFromRoute() {
      if (!this.menus.length) return;
      
      const path = this.$route.path;
      const pathParts = path.split("/").filter(part => part);
      
      if (pathParts.length > 0) {
        const mainPath = "/" + pathParts[0];
        const menu = this.menus.find((m) => m.path === mainPath);
        
        if (menu) {
          this.currentMenu = menu;
          this.activeMenu = mainPath;
          
          if (pathParts.length > 1) {
            this.activeSubMenu = pathParts[1];
          } else if (menu.children && menu.children.length) {
            // 如果是一级菜单但没有二级菜单路径，默认选中第一个二级菜单
            this.activeSubMenu = menu.children[0].path;
          } else {
            this.activeSubMenu = "";
          }
        }
      }
    },
  },
  created() {
    // 初始化菜单数据
    this.initMenu();
    // 获取未读消息数量
    this.getUnreadCount();
  },
  mounted() {
    // 定时获取未读消息数量（每分钟）
    this.messageTimer = setInterval(() => {
      this.getUnreadCount();
    }, 60000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.messageTimer) {
      clearInterval(this.messageTimer);
    }
  },
};
</script>

<style>
.layout {
  height: 100vh;
  display: flex;
  background: #f5f6fa;
}

/* 一级菜单 */
.sidebar {
  width: 120px;
  background: linear-gradient(180deg, #2d3a4b 0%, #22304a 100%);
  box-shadow: 2px 0 8px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  transition: width 0.3s;
  z-index: 10;
}
.logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  /* margin-bottom: 8px; */
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.08);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.menu-title {
  display: inline-block;
  width: 3em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  color: #fff;
  font-size: 15px;
}
.sidebar-menu .el-menu-item {
  justify-content: center;
  text-align: center;
  padding: 0;
}
.sidebar-menu .el-menu-item i {
  margin-right: 0;
  font-size: 22px;
}

/* 修复：确保选中状态优先级最高 */
.sidebar-menu .el-menu-item.is-active {
  background: #409eff !important;
  color: #fff !important;
}

.sidebar-menu .el-menu-item.is-active .menu-title {
  color: #fff !important;
}

.sidebar-menu .el-menu-item.is-active i {
  color: #fff !important;
}

/* 屏蔽一级菜单 hover 效果，仅保留选中高亮 */
.sidebar-menu .el-menu-item:hover:not(.is-active),
.sidebar-menu .el-menu-item:focus:not(.is-active) {
  background: transparent !important;
  color: inherit !important;
}

.sidebar-menu .el-menu-item:hover:not(.is-active) .menu-title,
.sidebar-menu .el-menu-item:focus:not(.is-active) .menu-title {
  color: #fff !important;
}

.sidebar-menu .el-menu-item:hover:not(.is-active) i,
.sidebar-menu .el-menu-item:focus:not(.is-active) i {
  color: #bfcbd9 !important;
}

/* 二级菜单 */
.sub-sidebar {
  width: 180px;
  background: #fff;
  color: #222;
  box-shadow: 2px 0 8px 0 rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  z-index: 9;
  transition: width 0.3s;
}

.sub-sidebar.collapsed {
  width: 0;
  overflow: hidden;
}

.sub-sidebar-menu {
  background: #fff !important;
  border-right: none;
  margin-top: 16px;
  width: 100%;
}

.sub-sidebar-menu.el-menu--collapse {
  width: 0;
}

.sub-sidebar-menu.el-menu--collapse .el-menu-item {
  display: none;
}

.sub-sidebar-menu .el-menu-item {
  font-size: 15px;
  /* margin: 4px 12px; */
  height: 44px !important;
  line-height: 44px !important;
  color: #222 !important;
  background: #fff !important;
  transition: background 0.2s, color 0.2s;
  text-align: center;
}
.sub-sidebar-menu .el-menu-item.is-active,
.sub-sidebar-menu .el-menu-item:hover {
  background: #e6f7ff !important;
  color: #409eff !important;
}

/* 主内容区 */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.header {
  height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  box-shadow: 0 1px 8px rgba(0, 21, 41, 0.06);
  margin-bottom: 12px;
}
.header-left i {
  font-size: 22px;
  color: #409eff;
  cursor: pointer;
  transition: color 0.2s;
}
.header-left i:hover {
  color: #67c23a;
}
.user-info {
  color: #606266;
  font-size: 15px;
  cursor: pointer;
  padding: 0 8px;
  border-radius: 6px;
  transition: background 0.2s;
}
.user-info:hover {
  background: #f5f7fa;
}
.content {
  flex: 1;
  padding: 0px 10px 0px 10px;
  background: #f5f6fa;
  /* border-radius: 12px; */
  min-height: 0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin: 0 8px 8px 0;
  overflow: auto;
}
.columns-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60px; /* 推荐高度 */
  width: 100%;
  user-select: none;
}
.columns-vertical i {
  font-size: 26px;
  margin: 0 0 4px 0;
  display: block;
  line-height: 1;
}
.columns-vertical .menu-title {
  font-size: 16px;
  color: #fff;
  margin: 0;
  line-height: 1.2;
  display: block;
  font-weight: 500;
  letter-spacing: 1px;
}
.sidebar-menu .el-menu-item {
  height: 60px !important;
  line-height: 60px !important;
  padding: 0;
  justify-content: center;
  text-align: center;
  margin: 6px 0;
}

.el-menu--collapse {
  width: 0px !important; /* 自定义折叠宽度 */
}

.el-menu--collapse el-menu-item {
  display: none !important;
}

.el-menu {
  border: 0px !important;
}

@media (max-width: 1200px) {
  .sidebar {
    width: 60px;
  }
  .sub-sidebar {
    width: 60px;
  }
  .logo {
    font-size: 16px;
  }
  .content {
    padding: 16px;
  }
}

/* 表格容器样式 */
.el-table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin: 16px 0;
}

/* 表头样式 */
.el-table th {
  background-color: #f8fafc !important;
  color: #1f2937 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 16px 0 !important;
  border-bottom: 1px solid #e5e7eb !important;
}

/* 表格单元格样式 */
.el-table td {
  padding: 16px 0 !important;
  font-size: 14px !important;
  color: #4b5563 !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

/* 表格行悬停效果 */
.el-table tbody tr:hover > td {
  background-color: #f8fafc !important;
  transition: background-color 0.2s ease;
}

/* 表格行选中效果 */
.el-table tbody tr.current-row > td {
  background-color: #eef2ff !important;
}

/* 表格边框样式 */
.el-table--border {
  border: 1px solid #e5e7eb !important;
}

.el-table--border th,
.el-table--border td {
  border-right: 1px solid #e5e7eb !important;
}

/* 表格斑马纹样式 */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f9fafb !important;
}

/* 表格内按钮样式 */
.el-table .el-button {
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.el-table .el-button--text {
  color: #3b82f6;
}

.el-table .el-button--text:hover {
  color: #2563eb;
  background-color: #eef2ff;
}

/* 表格内状态标签样式 */
.el-table .el-tag {
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
}

/* 表格内图标样式 */
.el-table .el-icon {
  font-size: 16px;
  vertical-align: middle;
  margin-right: 4px;
}

/* 表格分页样式 */
.el-pagination {
  margin-top: 20px;
  padding: 0;
  justify-content: flex-end;
}

.el-pagination .el-pagination__total {
  margin-right: 16px;
  color: #6b7280;
}

.el-pagination .btn-prev,
.el-pagination .btn-next {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  padding: 0 12px;
  margin: 0 4px;
}

.el-pagination .el-pager li {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  margin: 0 4px;
  font-weight: 500;
}

.el-pagination .el-pager li.active {
  background-color: #3b82f6;
  color: #fff;
  border-color: #3b82f6;
}

/* 表格空数据样式 */
.el-table__empty-block {
  min-height: 200px;
}

.el-table__empty-text {
  color: #9ca3af;
  font-size: 14px;
}

/* 表格加载状态样式 */
.el-table__loading {
  background-color: rgba(255, 255, 255, 0.9);
}

.el-table__loading .el-loading-spinner {
  margin-top: 20px;
}

.header-right {
  display: flex;
  align-items: center;
}

.notification-icon {
  margin-right: 20px;
  cursor: pointer;
  position: relative;
}

.notification-icon i {
  font-size: 22px;
  color: #606266;
  transition: color 0.2s;
}

.notification-icon i:hover {
  color: #409eff;
}

.notification-icon .el-badge__content {
  background-color: #f56c6c;
  border: none;
}
</style> 